// main.js or main.ts
import { createApp } from 'vue'
import App from './App.vue'
import { createRouter, createWebHistory } from 'vue-router'
/* eslint-disable */ 
import Firmalar from './components/Pages/FirmalarScreen.vue'
import UnderConst from './components/Pages/UnderConst.vue'
import HomeScreen from './components/Pages/HomeScreen.vue'
import AboutScreen from './components/Pages/AboutScreen.vue'
import ServicesScreen from './components/Pages/ServicesScreen.vue'
import ActivitiesScreen from './components/Pages/ActivitiesScreen.vue'
import NewsScreen from './components/Pages/NewsScreen.vue'
import ContactScreen from './components/Pages/ContactScreen.vue'
import InformationScreen from './components/Pages/InformationScreen.vue'
import DuyuruScreen from './components/Pages/DuyuruScreen.vue'
import '@fortawesome/fontawesome-free/css/all.css'
import KurucularScreen from './components/Pages/KurucularScreen.vue'
import KurulScreen from './components/Pages/KurulScreen.vue'
import TesekkurScreen from './components/Pages/TesekkurScreen.vue'
import Taziye from './components/Pages/TaziyeScreen.vue'
import FirmaDetayScreen from './components/Pages/FirmaDetayScreen.vue'
import ToolsScreen from './components/Pages/ToolsScreen.vue'
import ToplantiNotlari from './components/Pages/ToplantiNotlari.vue'
import SmsScreen from './components/Pages/SmsScreen.vue'
import DistrictScreen from './components/Pages/DistrictScreen.vue'
import DISTRICTS from './data/districts'
import FIRMALAR from './data/firmalar'
import slugify from './utils'

if (window.location.hash.startsWith('#/')) {
  const cleanPath = window.location.hash.slice(1)
  window.history.replaceState(null, '', cleanPath)
}

const routes = [
  { path: '/', component: HomeScreen },
  { path: '/firmalar', component: Firmalar },
  { path: '/ilanlar', component: UnderConst },
  { path: '/hakkimizda', component: AboutScreen },
  { path: '/anasayfa', component: HomeScreen },
  { path: '/hizmetlerimiz', component: ServicesScreen },
  { path: '/haberler', component: NewsScreen },
  { path: '/iletisim', component: ContactScreen },
  { path: '/information', redirect: '/sss' },
  { path: '/sss', component: InformationScreen },
  { path: '/etkinlikler', component: ActivitiesScreen },
  { path: '/kurucular', component: KurucularScreen },
  { path: '/kurullar', component: KurulScreen },
  { path: '/tesekkur', component: TesekkurScreen },
  { path: '/duyuru', component: DuyuruScreen },
  { path: '/taziye', component: Taziye },
  { path: '/toplanti', component: ToplantiNotlari },
  { path: '/sms', component: SmsScreen },
  { path: '/tools', component: ToolsScreen },
  { path: '/ilceler/:slug', component: DistrictScreen },
  {
    path: '/firma/:slug', component: FirmaDetayScreen
  },
  { path: '/:pathMatch(.*)*', name: 'NotFound', component: UnderConst },
]

const router = createRouter({
  history: createWebHistory(),
  routes,
  scrollBehavior(to, from, savedPosition) {
    // Always scroll to top
    return { top: 0 }
  }
})

const defaultTitle = "Ankara Ağrılılar Derneği | Ankara'daki Ağrılılar, Doğubayazıtlılar ve Patnoslular"
const defaultDescription = "Ankara Ağrılılar Derneği; Mamak, Keçiören, Sincan, Etimesgut, Yenimahalle, Altındağ ve tüm Ankara'da yaşayan Ağrılıları, Doğubayazıtlıları, Patnosluları ve Ağrı ilçelerinden hemşehrilerimizi dayanışma çatısında buluşturur."
const defaultKeywords = "Ankara Ağrılılar Derneği, Ankara Ağrılılar, Ankara'daki Ağrılılar, Ağrılılar Ankara, Ankara Doğubayazıtlılar, Ankara Patnoslular, Mamak Ağrılılar, Keçiören Ağrılılar, Sincan Ağrılılar, Etimesgut Ağrılılar, Yenimahalle Ağrılılar, Altındağ Ağrılılar, Ankara Ağrı otobüs bileti, Ankara Ağrı bilet, Ankara Ağrılı firmalar, Ankara Ağrılı iş ilanları, Ankara taziye duyurusu"

const routeMeta = {
  '/anasayfa': {
    title: "Ankara Ağrılılar Derneği | Ankara'daki Ağrılılar",
    description: "Ankara Ağrılılar Derneği; Mamak, Keçiören, Sincan, Etimesgut ve Ankara'nın tüm ilçelerinde yaşayan Ağrılıları, Doğubayazıtlıları, Patnosluları, aileleri, gençleri ve esnafları bir araya getirir.",
    keywords: defaultKeywords
  },
  '/hakkimizda': {
    title: "Hakkımızda | Ankara Ağrılılar Derneği ve Ağrı İlçe Hemşehri Ağı",
    description: "Ankara Ağrılılar Derneği hakkında bilgi alın. Ankara'daki Ağrılılar, Doğubayazıtlılar, Patnoslular, Mamak, Keçiören, Sincan, Etimesgut ve diğer ilçelerde yaşayan hemşehriler için dayanışma çatısı.",
    keywords: "Ankara Ağrılılar Derneği hakkımızda, Başkent Ağrılılar Derneği, Ankara Ağrı derneği, Ankara Doğubayazıtlılar, Ankara Patnoslular, Mamak Ağrılılar, Keçiören Ağrılılar, Sincan Ağrılılar, Etimesgut Ağrılılar, Ankara Ağrılılar WhatsApp grubu"
  },
  '/hizmetlerimiz': {
    title: "Hizmetlerimiz | Ankara Ağrılılar, Doğubayazıtlılar ve Patnoslular",
    description: "Ankara Ağrılılar Derneği hizmetleri: Mamak, Keçiören, Sincan, Etimesgut ve tüm Ankara'daki Ağrılılar için iş bulma, firma tanıtımı, sosyal yardım, bilet ve ulaşım bilgisi, taziye duyurusu, öğrenci desteği ve hemşehri dayanışması.",
    keywords: "Ankara Ağrılılar hizmetleri, Ankara Doğubayazıtlılar, Ankara Patnoslular, Mamak Ağrılılar, Keçiören Ağrılılar, Sincan Ağrılılar, Etimesgut Ağrılılar, Ankara Ağrı otobüs bileti, Ankara Ağrı bilet, Ankara Ağrılı iş ilanları, Ağrılı firmalar Ankara, Ankara taziye duyurusu, Ankara Ağrılı öğrenciler"
  },
  '/etkinlikler': {
    title: "Etkinlikler | Ankara Ağrılılar Derneği",
    description: "Ankara Ağrılılar Derneği etkinlikleri; piknik, toplantı, taziye, düğün duyurusu, sosyal destek, kültürel buluşma ve Mamak, Keçiören, Sincan, Etimesgut çevresindeki hemşehri faaliyetleri.",
    keywords: "Ankara Ağrılılar etkinlikleri, Ağrılılar piknik Ankara, Ankara Ağrılılar toplantı, Ankara Ağrılı düğün duyurusu, Ankara taziye duyurusu, Mamak Ağrılılar etkinlik, Keçiören Ağrılılar etkinlik"
  },
  '/haberler': {
    title: "Ağrı Haberleri | Doğubayazıt, Patnos ve Ankara Ağrılılar Gündemi",
    description: "Ağrı haberleri, Doğubayazıt haberleri, Patnos haberleri ve Ankara'daki Ağrılılar için memleket gündemi. İlçe haberleri, ulaşım, ekonomi, eğitim ve sosyal gelişmeler.",
    keywords: "Ağrı haberleri, Doğubayazıt haberleri, Patnos haberleri, Ankara Ağrılılar haberleri, Ağrı son dakika, Ağrı ilçeleri haber, Diyadin haberleri, Eleşkirt haberleri, Tutak haberleri, Taşlıçay haberleri, Hamur haberleri"
  },
  '/iletisim': {
    title: "İletişim | Ankara Ağrılılar Derneği Telefon, WhatsApp ve Konum",
    description: "Ankara Ağrılılar Derneği iletişim bilgileri. Dernek hattını arayın, WhatsApp grubuna katılın, konumu açın. Mamak, Keçiören, Sincan, Etimesgut ve Ankara'daki Ağrılılar için iletişim sayfası.",
    keywords: "Ankara Ağrılılar iletişim, Ankara Ağrılılar Derneği telefon, Ankara Ağrılılar WhatsApp grubu, Başkent Ağrılılar Derneği iletişim, Mamak Ağrılılar iletişim, Keçiören Ağrılılar, Sincan Ağrılılar, Etimesgut Ağrılılar, Ankara Ağrı derneği konum"
  },
  '/firmalar': {
    title: "Ankara Ağrılı Firmalar | Ağrılı Esnaflar, İşletmeler ve Hizmetler",
    description: "Ankara'daki Ağrılı firmalar, hemşehri esnaflar ve güvenilir hizmet veren işletmeler. Mamak, Keçiören, Sincan, Etimesgut ve Ankara genelinde vize danışmanlığı, inşaat, sigorta, hukuk, restoran, dekorasyon ve usta hizmetleri.",
    keywords: "Ankara Ağrılı firmalar, Ağrılı esnaflar Ankara, Mamak Ağrılı esnaf, Keçiören Ağrılı esnaf, Sincan Ağrılı firmalar, Etimesgut Ağrılı firmalar, Ağrılı usta Ankara, Ankara Ağrılı vize danışmanlığı, Ankara Ağrılı inşaat firmaları, Ankara Ağrılı sigorta, Ankara Ağrılı hukuk bürosu, Ankara Ağrılı restoran"
  },
  '/kurucular': {
    title: "Kurucular | Ankara Ağrılılar Derneği",
    description: "Ankara Ağrılılar Derneği kurucuları ve derneğin kuruluşunda emeği geçen hemşehrilerimiz.",
    keywords: "Ankara Ağrılılar Derneği kurucuları, Başkent Ağrılılar Derneği kurucular, AĞ-DER kurucular"
  },
  '/kurullar': {
    title: "Kurullar | Ankara Ağrılılar Derneği Çalışma ve İlçe Temsil Kurulları",
    description: "Ankara Ağrılılar Derneği çalışma kurulları, sosyal destek ekipleri ve Ağrı Merkez, Patnos, Doğubayazıt, Diyadin, Eleşkirt, Tutak, Taşlıçay, Hamur ilçe temsil kurulları.",
    keywords: "Ankara Ağrılılar Derneği kurulları, Ağrı ilçe temsil kurulları Ankara, Ankara Patnos temsil kurulu, Ankara Doğubayazıt temsil kurulu, sosyal destek kurulu, gençlik eğitim kurulu"
  },
  '/sss': {
    title: "Bilgi | Ankara Ağrılılar Derneği Üyelik, Bağış ve Dayanışma",
    description: "Ankara Ağrılılar Derneği bilgi sayfası. Üyelik, WhatsApp grubu, dernek adresi, telefon, konum, bağış, Ankara Ağrı bilet bilgileri, taziye ve resmi hesap bilgileri.",
    keywords: "Ankara Ağrılılar Derneği bilgi, Ankara Ağrılılar iletişim, Ankara Ağrılılar WhatsApp grubu, Mamak Ağrılılar, Keçiören Ağrılılar, Ankara Ağrı bilet, Ankara taziye, Başkent Ağrılılar Derneği hesap bilgileri"
  }
}

const setMeta = (selector, content, attribute = 'name') => {
  let element = document.head.querySelector(`meta[${attribute}="${selector}"]`)
  if (!element) {
    element = document.createElement('meta')
    element.setAttribute(attribute, selector)
    document.head.appendChild(element)
  }
  element.setAttribute('content', content)
}

const setCanonical = (href) => {
  let element = document.head.querySelector('link[rel="canonical"]')
  if (!element) {
    element = document.createElement('link')
    element.setAttribute('rel', 'canonical')
    document.head.appendChild(element)
  }
  element.setAttribute('href', href)
}

const setStructuredData = (data) => {
  const id = 'aad-route-structured-data'
  let element = document.getElementById(id)
  if (!data) {
    element?.remove()
    return
  }

  if (!element) {
    element = document.createElement('script')
    element.id = id
    element.type = 'application/ld+json'
    document.head.appendChild(element)
  }
  element.textContent = JSON.stringify(data)
}

const normalizePhoneForSchema = (phone) => {
  const digits = String(phone || '').replace(/\D/g, '')
  if (!digits) return ''
  if (digits.startsWith('90')) return `+${digits}`
  if (digits.startsWith('0')) return `+90${digits.slice(1)}`
  return `+90${digits}`
}

router.afterEach((to) => {
  const district = to.path.startsWith('/ilceler/')
    ? DISTRICTS.find((item) => item.slug === to.params.slug)
    : null
  const firma = to.path.startsWith('/firma/')
    ? FIRMALAR.find((item) => slugify(item.title) === to.params.slug)
    : null
  const pageMeta = routeMeta[to.path]

  const title = district
    ? `${district.communityName} | Ankara Ağrılılar Derneği`
    : firma
      ? `${firma.title} | Ankara Ağrılı Firma Rehberi`
    : pageMeta?.title || defaultTitle
  const description = district
    ? `${district.communityName} sayfası; Ankara'da yaşayan ${district.name} kökenli Ağrılı hemşehrilerimizi ilçe dernekleriyle dayanışma içinde ortak çatıya davet eder.`
    : firma
      ? `${firma.title}; ${firma.category} alanında Ankara'da hizmet veren Ağrılı hemşehri işletmesidir. Telefon, WhatsApp, adres ve konum bilgileriyle hemen iletişime geçin.`
    : pageMeta?.description || defaultDescription
  const keywords = district
    ? [...district.seoTerms, district.communityName, `${district.name} hemşehrileri Ankara`, 'Ankara Ağrılılar Derneği'].join(', ')
    : firma
      ? `${firma.title}, ${firma.category}, ${firma.contact}, Ankara Ağrılı firmalar, Ağrılı esnaflar Ankara, Ankara hemşehri firmaları, ${firma.adress}`
    : pageMeta?.keywords || defaultKeywords
  const canonicalPath = district
    ? `/ilceler/${district.slug}`
    : firma
      ? `/firma/${slugify(firma.title)}`
      : (to.path === '/' ? '/' : to.path)
  const canonicalUrl = `https://ankaraagrililardernegi.com${canonicalPath}`

  document.title = title
  setMeta('description', description)
  setMeta('keywords', keywords)
  setMeta('og:title', title, 'property')
  setMeta('og:description', description, 'property')
  setMeta('og:url', canonicalUrl, 'property')
  setMeta(
    'og:image',
    district
      ? (district.image.startsWith('http') ? district.image : `https://ankaraagrililardernegi.com${district.image}`)
      : 'https://ankaraagrililardernegi.com/img/logo.jpg',
    'property'
  )
  setCanonical(canonicalUrl)
  setStructuredData(firma ? {
    '@context': 'https://schema.org',
    '@type': 'LocalBusiness',
    name: firma.title,
    description: firma.desciption,
    telephone: normalizePhoneForSchema(firma.phone),
    address: firma.adress,
    url: canonicalUrl,
    areaServed: 'Ankara',
    category: firma.category,
    founder: firma.contact,
    sameAs: firma.location ? [firma.location] : []
  } : null)
})

const app = createApp(App)
app.use(router)
app.mount('#app')
